import React, {useEffect, useRef, useState} from 'react';
import {Edit, Loading, SelectInput, SimpleForm, TextInput, useQueryWithStore} from 'react-admin'
import {
    Grid as KGrid,
    GridColumn as Column,
    GridColumnMenuCheckboxFilter,
    GridToolbar
} from '@progress/kendo-react-grid';
import {Button as KButton} from "@progress/kendo-react-buttons"
import {connect, useDispatch, useSelector} from "react-redux";
import TextField from '@material-ui/core/TextField';
import Grid from "@material-ui/core/Grid";
import AddOverTimeDialog from "../dialogs/addOverTime";
import CaptionedField from "../../UIComponents/captionedField";
import AddBonusPopover from "../dialogs/addBonusPopover";
import EarningsPopover from "../dialogs/earningsPopover";
import DeductionsPopover from "../dialogs/deductionsPopover";
import AddPayrollDeductionPopover from "../dialogs/addPayrollDeductionPopover";
import moment from "moment";
import PayrollExcelExport from "./excelExport";
import MultiCurrency from "../multiCurrency";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {DatePicker} from "@material-ui/pickers";
import {filterBy, orderBy} from '@progress/kendo-data-query';
import Divider from "@material-ui/core/Divider";
import SetTimeSheetDialog from "../dialogs/editTimeSheet";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import CardContent from "@material-ui/core/CardContent";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import {Typography} from "../../UIComponents/Wrappers";
import NumberFormat from 'react-number-format';
import AddBonusDialog from "../dialogs/bonusDialog";
import {MultiCurrencyContext} from "../../contexts";
import FormLabel from "@material-ui/core/FormLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Radio from "@material-ui/core/Radio";
import SyncMatesDialog from "../dialogs/syncMatesDialog";
import {multiDateFun} from "../../Helpers/multiDateFun";
import DistEarnings from "../dialogs/distEarnings";
import ImportEarningsDeductionsFromFile from "./importEarningsAndDeductions";
import ImportPayrollUpdates from './importPayrollUpdates';
import {DateRangePicker} from "@progress/kendo-react-dateinputs";
import Values from 'values.js'
import MergePayrollDialog from "../dialogs/MergePayrollDialog";
import GroupBonus from "../dialogs/groupBonusDialog";
import NotesPopover from "../dialogs/notesPopover";
import CurrencyRatesPopover from '../dialogs/currencyRatesPopover';
import { Button } from "@material-ui/core";
import SaveIcon from '@material-ui/icons/Save';
import RestoreIcon from '@material-ui/icons/Restore';
import Menu from '@material-ui/core/Menu';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import SearchIcon from '@material-ui/icons/Search';
import CancelIcon from '@material-ui/icons/Cancel';
import InputAdornment from '@material-ui/core/InputAdornment';
import { ButtonGroup } from '@material-ui/core';
import { indexedDBService } from '../../services/indexedDBService';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import WithConfirm from '../../UIComponents/withConfirm';
import { useLocation } from 'react-router-dom';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import DropMenuButton from '../../UIComponents/DropMenuButton';
import Popover from '@material-ui/core/Popover';
import RefreshSelectedDialog from '../dialogs/RefreshSelectedDialog';
import BulkDeductionDialog from '../dialogs/bulkDeductionDialog';

const expand = props => {
    return <div>
        <Edit {...props}>
            <SimpleForm>
                <TextInput source="name"/>
            </SimpleForm>
        </Edit>
    </div>
}

function sort(x) {

}

// class DetailComponent extends GridDetailRow {
//     render() {
//         const dataItem = this.props.dataItem;
//         return (
//             <section>
//                 <p><strong>Basic Salary</strong> {dataItem.employee.basicSalary}</p>
//                <TextField value={dataItem.daysWorked} onChange={e=>console.log(e.target.value)}/>
//              </section>
//         );
//     }
// }

const getColor = (type) => {
    switch (type) {
        case 'attention':
            return 'red'

        case 'warning':
            return 'orange'
        default:
            return 'black'
    }
}
const color = new Values('hsl(44deg 98% 50% / 1)')
const MultiCurrencyCell = (props) => {
    const value = props.dataItem[props.field];
    const attention = (props.field === "additionalEarningsTotal" && props.dataItem['additionalFixedEarningsOriginal'] && props.dataItem['additionalFixedEarningsOriginal'].toFixed(2) !== props.dataItem['additionalFixedEarnings'].toFixed(2)) ||
        // (props.field === "cash" &&   props.dataItem['fullBasicSalary'] && props.dataItem['fullBasicSalary'].toFixed(2) !==  props.dataItem['basicSalary'].toFixed(2))||
        (props.field === "totalDeductionIncludingCash" && props.dataItem['fixedDeductionsTotals'] && props.dataItem['fixedDeductionsTotals'].toFixed(2) !== props.dataItem['payrollFixedDeductions'].reduce((sum, cv) => sum + cv.originalValue, 0).toFixed(2)) ||
        (props.field === "basicSalary" && props.dataItem['fullBasicSalary'] && props.dataItem['fullBasicSalary'].toFixed(2) !== props.dataItem['basicSalary'].toFixed(2)) ||
        (props.field === "cash" && props.dataItem['cash'] < 0)

    ;
    const warn = (props.field === "totalDeductionIncludingCash" && props.dataItem['basicAbsentDeduction'] > 0)

    return <td style={{
        color: props.attention || attention ? 'red' : 'black',
        backgroundColor: warn ? color.tint((props.dataItem['cash'] * 50) / (props.dataItem['cash'] + props.dataItem['basicAbsentDeduction'])).hexString() : 'transparent'
    }}><MultiCurrency value={value}/><span style={{fontSize: 'large'}}>{props.attention || attention ? "*" : ''}</span>
    </td>
}

const NameCell = (props) => {
    const hasRemarks = props.dataItem.remarks && props.dataItem.remarks.length > 0;
    return <td style={{
        backgroundColor: hasRemarks ? '#c4deffff' : 'transparent'
    }}>{props.dataItem[props.field]}</td>
}

const RemarksCell = (props) => {
    const remarks = props.dataItem.remarks || [];
    return <td>
        {remarks.map((remark, index) => (
            <div key={index} style={{
                color: remark.type === 'check' ? '#d32f2f' : '#1976d2',
                fontWeight: remark.type === 'check' ? 'bold' : 'normal',
                marginBottom: index < remarks.length - 1 ? '2px' : '0'
            }}>
                {remark.text}
            </div>
        ))}
    </td>
}


const DetailPayroll = props => {
    const { dataItem, onItemChange, overtimeTypes, isEdit, isApproved, usedCurrencyRates, companySettings } = props

    const allowManualAbsentDeduction = companySettings&&companySettings.allowManualAbsentDeduction&&(companySettings.allowManualAbsentDeduction.value==='yes'||companySettings.allowManualAbsentDeduction.value==='true')
    console.log({allowManualAbsentDeduction, companySettings})
    
    const [extraIncomeTaxAnchor, setExtraIncomeTaxAnchor] = useState(null);
    return <div>
        <Grid container spacing={3}>
      
        <Grid item xs={3}>
            {/*{dataItem.payrollDate.toString()}*/}
            <Grid container fullWidth>
                <Grid item xs={6}>
                <TextField fullWidth inputProps={{max: dataItem.totalDaysInPayPeriod, min: "0", step: "1"}} type="number"

key={dataItem.id}
label={`Normal Payable Days out of ${dataItem.totalDaysInPayPeriod} ${dataItem.originalPayDays && dataItem.originalPayDays !== dataItem.normalPayDays ? `* was ${dataItem.originalPayDays}` : ''}`}
value={dataItem.normalPayDays} onChange={e => onItemChange({
dataItem,
field: 'normalPayDays',
value: +e.target.value
})}/>
                </Grid>
                <Grid item xs={6}>

                    {/* in percentage */}
                    <TextField fullWidth inputProps={{max: 100, min: "0", step: "1"}} type="number"
                    label={`Normal Payable Days in Percentage`}
                    value={+(dataItem.normalPayDays/dataItem.totalDaysInPayPeriod*100).toFixed(2)} onChange={e => onItemChange({
                        dataItem,
                        field: 'normalPayDays',
                        value: +e.target.value * dataItem.totalDaysInPayPeriod / 100
                    })}/>

                </Grid>
            </Grid>
          

            <FormControlLabel control={<Checkbox
                checked={(dataItem.backPayDays + dataItem.forwardPayDays) > 0}
                color="primary"
                onChange={e => onItemChange(
                    {
                        dataItem,
                        field: 'backPayDays',
                        value: e.target.checked ? 1 : 0
                    })}
                inputProps={{'aria-label': 'primary checkbox'}}
            />} label={<Typography size='sm'>Extra Days</Typography>}/>


            {(dataItem.backPayDays + dataItem.forwardPayDays) > 0 && <Grid container>
                <Grid item xs={6}>
                    <TextField fullWidth inputProps={{max: dataItem.totalDaysInPayPeriod, min: "0", step: "1"}}
                               type="number" key={dataItem.id}
                               label={`Back Pay Days`}
                               value={dataItem.backPayDays} onChange={e => onItemChange(
                        {
                            dataItem,
                            field: 'backPayDays',
                            value: +e.target.value
                        })}/>
                </Grid>
                <Grid item xs={6}>

                    <TextField fullWidth inputProps={{max: dataItem.totalDaysInPayPeriod, min: "0", step: "1"}}
                               type="number" key={dataItem.id}
                               label={`Forward Pay Days`}
                               value={dataItem.forwardPayDays} onChange={e => onItemChange(
                        {
                            dataItem,
                            field: 'forwardPayDays',
                            value: +e.target.value
                        })}/>

                </Grid>
            </Grid>}
            {/*<p><strong>{dataItem.employmentType!=='Casual'?'Basic Salary':'Daily Wadge'}</strong> {dataItem.basicSalary}</p>*/}
            {/*    <CaptionedField label='payDays' value= {dataItem.payDays}/>*/}


            <Grid container>
                <Grid item xs={6}>
                    <CaptionedField label={dataItem.employmentType !== 'Casual' ? `Basic Salary of ${dataItem.basicCurrency&&dataItem.basicCurrency!=='ETB' ? `${dataItem.basicCurrency} ${dataItem.salaryInBasicCurrency}` : 'ETB'} ` : 'Daily Wadge'}
                            labelValue={dataItem.fullBasicSalary} value={dataItem.basicSalary}/>
                </Grid>
                <Grid item xs={6}>
                    <TextField fullWidth
                               type="number" 
                               key={dataItem.id}
                               label={`Salary Adjustment (${dataItem.basicCurrency||'ETB'})`}
                               value={dataItem.basicSalaryAdjustment}
                               onChange={e => {
                                   const value = e.target.value;
                                   // Use Number() instead of + for safer conversion
                                   onItemChange({
                                       dataItem,
                                       field: 'basicSalaryAdjustment',
                                       value: value === '' ? 0 : Number(value)
                                   });
                               }}
                    />
                </Grid>
            </Grid>


            {/*<TextField value={dataItem.daysWorked} onChange={e=>onChange({*/}
            {/*dataItem,*/}
            {/*field:'daysWorked',*/}
            {/*value:e.target.value*/}
            {/*})}/>*/}
            <TextField fullWidth inputProps={{max: dataItem.totalWorkDays, min: "0", step: "1"}} type="number"
                       key={"cdsds"} label={`Days Worked out of ${dataItem.totalWorkDays.toFixed(2)}`}
                       value={dataItem.daysWorked} onChange={e => onItemChange(
                {
                    dataItem,
                    field: 'daysWorked',
                    value: +e.target.value
                })}/>

            {/*<TextField fullWidth disabled={dataItem.fromTimeAttendance===dataItem.hoursWorked}  inputProps={{min:"0", step: "1" }}   type="number" key={dataItem.id} label={!(dataItem.fromTimeAttendance===dataItem.hoursWorked)?`Payable Hours of ${(dataItem.monthlyHours||0).toFixed(2)}`:'Payable Hours ⏰'} value={dataItem.hoursWorked} onChange={e=>onItemChange(*/}
            {/*    {*/}
            {/*        dataItem,*/}
            {/*        field:'hoursWorked',*/}
            {/*        value:+e.target.value*/}
            {/*    })}/>*/}

            <NumberFormat fullWidth  inputProps={{max: dataItem.totalWorkDays, min: "0", step: "1"}}
                          type="number" customInput={TextField} decimalScale={2} label="Expected Hours"
                          value={dataItem.monthlyHours} onChange={e => onItemChange(
                {
                    dataItem,
                    field: 'monthlyHours',
                    value: +e.target.value
                })}/>


            <NumberFormat fullWidth  inputProps={{max: dataItem.monthlyHours, min: "0", step: "1"}}
                          type="number" customInput={TextField} decimalScale={2}
                          label={!(dataItem.fromTimeAttendance === dataItem.hoursWorked) ? `Payable Hours of  ${(dataItem.monthlyHours || 0).toFixed(2)}` : 'Payable Hours ⏰'}
                          value={dataItem.hoursWorked} onChange={e => onItemChange(
                {
                    dataItem,
                    field: 'hoursWorked',
                    value: +e.target.value
                })}/>


            <NumberFormat fullWidth  inputProps={{max: dataItem.monthlyHours, min: "0", step: "1"}}
                          type="number" customInput={TextField} decimalScale={2}
                          label={!(dataItem.fromTimeAttendance === dataItem.hoursWorked) ? `Actual Hours of  ${(dataItem.monthlyHours || 0).toFixed(2)}` : 'Actual Hours ⏰'}
                          value={dataItem.actualHoursWorked} onChange={e => onItemChange(
                {
                    dataItem,
                    field: 'actualHoursWorked',
                    value: +e.target.value
                })}/>

<Grid container>
    <Grid item xs={6}>
        <NumberFormat fullWidth  inputProps={{min: "0", step: "1"}} type="number"
                          customInput={TextField}
                          label={`Avg Daily Hour, Service Hour = ${dataItem.serviceHours  +(dataItem.deductServiceHour?(dataItem.missedHours||0):0)} ${dataItem.deductServiceHour ? `- ${dataItem.missedHours || 0} = ${dataItem.serviceHours}` : ''}`}
                          value={dataItem.dailyServiceHour} onChange={e => onItemChange(
                {
                    dataItem,
                    field: 'dailyServiceHour',
                    value: +e.target.value
                })}/>
    </Grid>
    
    <Grid item xs={6}>
    <NumberFormat fullWidth  inputProps={{min: "0", step: "1"}} type="number"
                          customInput={TextField}
                          label={`Service Days`}
                          value={dataItem.serviceDays} onChange={e => onItemChange(
                {
                    dataItem,
                    field: 'serviceDays',
                    value: +e.target.value
                })}/>
        </Grid>
        </Grid>
            <CaptionedField label='Earned Salary (Working Hours or Days)' value={dataItem.earnedSalary}/>
            {/*<CaptionedField label='Outstanding Loan' value= {dataItem.outstandingLoan}/>*/}
            <Divider/>
            {isEdit && <FormControlLabel control={<Checkbox
                checked={dataItem.emailSent}
                color="primary"
                onChange={e => onItemChange(
                    {
                        dataItem,
                        field: 'emailSent',
                        value: e.target.checked
                    })}
                inputProps={{'aria-label': 'primary checkbox'}}
            />} label={<Typography size='sm'>Email is sent</Typography>}/>}

            {isEdit && <FormControlLabel control={<Checkbox
                checked={dataItem.publishId}
                color="primary"
                onChange={e => onItemChange(
                    {
                        dataItem,
                        field: 'publishId',
                        value: e.target.checked ? -1 : 0
                    })}
                inputProps={{'aria-label': 'primary checkbox'}}
            />} label={<Typography size='sm'>Published</Typography>}/>}


        </Grid>
        <Grid item xs={3}>
            <Grid container alignItems='center'>
                <Grid item>
                    <CaptionedField
                        label={`Fixed Earnings ${dataItem.additionalFixedEarningsOriginal && dataItem.additionalFixedEarnings.toFixed(2) !== dataItem.additionalFixedEarningsOriginal.toFixed(2) ? `* ${dataItem.additionalFixedEarningsOriginal.toFixed(2)}` : ''}`}
                        value={dataItem.additionalFixedEarnings}/>
                </Grid>
                <Grid item>
                    <EarningsPopover totalDaysInPayPeriod={dataItem.totalDaysInPayPeriod}
                                     earnings={dataItem.payrollFixedEarnings} onChange={items => onItemChange({
                        dataItem,
                        field: 'payrollFixedEarnings',
                        value: items
                    })}/>
                </Grid>

                {/*<FormControlLabel control={<Checkbox*/}
                {/*    checked={dataItem.omitTransportAllowance}*/}
                {/*    color="primary"*/}
                {/*    onChange={e=>onItemChange(*/}
                {/*        {*/}
                {/*            dataItem,*/}
                {/*            field:'omitTransportAllowance',*/}
                {/*            value:e.target.checked*/}
                {/*        })}*/}
                {/*    inputProps={{ 'aria-label': 'primary checkbox' }}*/}
                {/*/>} label={<Typography size='sm' >Omit Transport Allowance</Typography>} />*/}


            </Grid>

            <CaptionedField label='Overtime Total' value={dataItem.overtimeTotal}/>

            <AddOverTimeDialog overtimeTypes={overtimeTypes} overtimes={dataItem.overtimes} onAdd={ot => onItemChange({
                dataItem,
                field: 'overtimes',
                value: ot
            })}/>
            <CaptionedField label='Extra Earnings Total' value={dataItem.bonusesTotal}/>
            <AddBonusDialog key={JSON.stringify(dataItem.bonuses)} payroll={dataItem} bonuses={dataItem.bonuses}  usedCurrencyRates={usedCurrencyRates} actingAllowancePercentage={props.runPayroll.actingAllowancePercentage}
                            onAdd={ot => onItemChange({
                                dataItem,
                                field: 'bonuses',
                                value: ot
                            })}/>

            <Divider/>
            <Grid container alignItems='center'>
                <Grid item>
                    <CaptionedField
                        label={`Company Expenses ${dataItem['fixedExpensesTotals'].toFixed(2) !== dataItem['payrollFixedExpenses'].reduce((sum, cv) => sum + cv.originalValue, 0).toFixed(2) ? '*' : ''}`}
                        value={dataItem.fixedExpensesTotals}/>
                </Grid>
                <Grid item>
                    <DeductionsPopover deductions={dataItem.payrollFixedExpenses} onChange={items => onItemChange({
                        dataItem,
                        field: 'payrollFixedExpenses',
                        value: items
                    })}/>
                </Grid>
            </Grid>
            {/*<AddBonusPopover onAdd={b=>onItemChange({*/}
            {/*    dataItem,*/}
            {/*    field:'bonuses',*/}
            {/*    value:[...dataItem.bonuses,b]*/}
            {/*})}/>*/}
        </Grid>
        <Grid item xs={3}>
            <Grid container alignItems='center'>
                <Grid item>
                    <CaptionedField
                        label={`Fixed Deduction ${dataItem['fixedDeductionsTotals'].toFixed(2) !== dataItem['payrollFixedDeductions'].reduce((sum, cv) => sum + cv.originalValue, 0).toFixed(2) ? '*' : ''}`}
                        value={dataItem.fixedDeductionsTotals}/>
                </Grid>
                <Grid item>
                        <DeductionsPopover deductions={dataItem.payrollFixedDeductions} onChange={items => onItemChange({
                        dataItem,
                        field: 'payrollFixedDeductions',
                        value: items
                    })}/>
                </Grid>
            </Grid>
            <TextField  fullWidth inputProps={{max: "30", min: "0", step: "1"}} type="number" label={`Absent Days ${dataItem.penaltyAbsentDays?`${dataItem.penaltyAbsentDays} Penalty Days`:''}`}
                       value={dataItem.absentDays} onChange={e => onItemChange(
                {
                    dataItem,
                    field: 'absentDays',
                    value: +e.target.value
                })}/>

             <TextField disabled={!allowManualAbsentDeduction}   fullWidth  type="number" label={`Basic Absent Deduction`}
                       value={dataItem.basicAbsentDeduction} onChange={e => onItemChange(
                {
                    dataItem,
                    field: 'basicAbsentDeduction',
                    value: +e.target.value
                })}/>

            <TextField fullWidth inputProps={{max: "30", min: "0", step: "1"}} type="number"
                       label={`Leave Days ${dataItem.leaveDaysTaken}/${dataItem.leaveDaysEntitled}`}
                       value={dataItem.leaveDays} onChange={e => onItemChange(
                {
                    dataItem,
                    field: 'leaveDays',
                    value: +e.target.value
                })}/>

            <Grid container>

                <FormControlLabel control={<Checkbox
                    checked={dataItem.deductTransportIfAbsent}
                    color="primary"
                    onChange={e => onItemChange(
                        {
                            dataItem,
                            field: 'deductTransportIfAbsent',
                            value: e.target.checked
                        })}
                    inputProps={{'aria-label': 'primary checkbox'}}
                />} label={<Typography size='sm'>Deduction from Additional Earnings</Typography>}/>


                {dataItem.deductTransportIfAbsent &&
                <CaptionedField label='' value={dataItem.additionalEarningsAbsentDeduction}/>
                }
            </Grid>

            <CaptionedField label='Taxable Income' value={dataItem.taxableIncome}/>
            <Grid container alignItems='center'>
                <Grid item>
                    <CaptionedField label='Income Tax' value={dataItem.incomeTax}/>
                </Grid>
                <Grid item>
                    <IconButton size="small" onClick={e => setExtraIncomeTaxAnchor(e.currentTarget)}>
                        <MoreVertIcon style={{fontSize: 18}}/>
                    </IconButton>
                </Grid>
            </Grid>
            <Popover
                open={Boolean(extraIncomeTaxAnchor)}
                anchorEl={extraIncomeTaxAnchor}
                onClose={() => setExtraIncomeTaxAnchor(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <div style={{ padding: 16, minWidth: 250 }}>
                    <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: 12 }}>
                        Extra Income Tax Adjustment
                    </Typography>
                    <TextField
                        fullWidth
                        type="number"
                        label="Extra Income Tax"
                        value={dataItem.extraIncomeTax || 0}
                        onChange={e => onItemChange({
                            dataItem,
                            field: 'extraIncomeTax',
                            value: +e.target.value
                        })}
                        InputProps={{ inputProps: { step: 0.01 } }}
                    />
                </div>
            </Popover>

            <CaptionedField label='Loan Settlement/other Deductions'
                            value={dataItem.payrollDeductionTotal + dataItem.payrollDeductionTotalCash}/>
            {/*<CaptionedField label='Loan' value={dataItem.payrollLoan}/>*/}
            <AddPayrollDeductionPopover loans={dataItem.loans} payrollDeductions={dataItem.payrollDeductions}
                                        onAdd={ot => onItemChange({
                                            dataItem,
                                            field: 'payrollDeductions',
                                            value: ot
                                        })}/>
            {/*({dataItem.absentDays} days)*/}

            {/*<p>Absence <strong>{dataItem.absentDays}</strong> days    <strong>{dataItem.absenceDeduction}</strong></p>*/}
        </Grid>
        <Grid item xs={3}>
            <CaptionedField
                label={dataItem.employmentType !== 'Casual' ? `+Basic Salary ${dataItem.payDays != dataItem.totalDaysInPayPeriod ? `(${dataItem.payDays.toFixed(2)} days)` : ''}` : 'Daily Wadge'}
                value={dataItem.basicSalary}/>
            {dataItem.employmentType === 'Casual' &&
            <CaptionedField label={`X ${dataItem.daysWorked} Days`} value={dataItem.earnedSalary}/>}
            <CaptionedField label='+Additional Earnings' value={dataItem.additionalEarningsTotal}/>
            <Divider/>
            <CaptionedField label='Total Income' value={dataItem.totalIncome}/>
            <CaptionedField label='-Deductions' value={dataItem.totalDeduction}/>
            <Divider/>
            <CaptionedField label='Net' value={dataItem.netPay}/>
            <CaptionedField label='-Settlement' value={dataItem.payrollDeductionTotalCash}/>
            <Divider/>
            <CaptionedField label='Net Pay' value={dataItem.cash}/>
            {dataItem.costCenterItems && dataItem.costCenterItems.length && <div>Cost Centers</div>}
            {dataItem.costCenterItems && dataItem.costCenterItems.map(csi =>
                <CaptionedField label={csi.costCenterCode} value={csi.cash}/>)}
            {/*<p><strong>{dataItem.deductions}</strong></p>*/}
        </Grid>
        <Grid item xs={3}>
            <FormControl component="fieldset">
                <FormLabel component="legend">Status</FormLabel>
                <RadioGroup row defaultValue="Processing" aria-label="gender" name="gender1" value={dataItem.status}
                            onChange={e => onItemChange(
                                {
                                    dataItem,
                                    field: 'status',
                                    value: e.target.value
                                })}>
                    <FormControlLabel labelPlacement="top" value="Processing" control={<Radio color="primary"/>}
                                      label="Processing"/>
                    <FormControlLabel labelPlacement="top" value="Paid" control={<Radio color="primary"/>}
                                      label="Paid"/>
                    <FormControlLabel labelPlacement="top" value="Held" control={<Radio color="primary"/>}
                                      label="Held"/>
                </RadioGroup>
            </FormControl>
        </Grid>
        <Grid item xs={3}>
        
            <NotesPopover
                notes={dataItem.notes || []}
                currentUser={props.currentUser && props.currentUser.name}
                employeeId={dataItem.employeeId}
                payrollDate={props.runPayroll.payrollDate}
                onChange={notes => onItemChange({
                    dataItem,
                    field: 'notes',
                    value: notes
                })}

            />
        </Grid>
      { dataItem.reviewNotes&& <Grid item xs={3}>
        <Typography weight="bold">Reviewer Notes</Typography>
            {dataItem.reviewNotes.map((n, index) => (
                <div key={index} style={{ marginBottom: '8px', padding: '8px', border: '1px solid #eee', borderRadius: '4px' }}>
                    <Typography variant="body2" style={{ marginBottom: '4px' }}>
                        <strong>Note:</strong> {n.note}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                        By {n.remarkUser} on {moment(n.remarkDate).format('YYYY-MM-DD HH:mm')}
                    </Typography>
                </div>
            ))}
        </Grid>}


            {dataItem.employee.notes && dataItem.employee.notes.length > 0 && (
                <Grid item xs={3}>
        <ExpansionPanel style={{ marginTop: 8 }}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="body2">
                    Previous Notes ({dataItem.employee.notes.length}): {dataItem.employee.notes[0].note.length > 50 ? dataItem.employee.notes[0].note.substring(0, 50) + '...' : dataItem.employee.notes[0].note}
                </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails style={{ flexDirection: 'column' }}>
                {dataItem.employee.notes.sort((a, b) => new Date(b.noteDate) - new Date(a.noteDate)).map((note, index) => (
                    <div key={index} style={{ marginBottom: index < dataItem.employee.notes.length - 1 ? 8 : 0, padding: 8, border: '1px solid #eee', borderRadius: 4 }}>
                        <Typography variant="body2" style={{ marginBottom: 4 }}>
                            {note.note}   -   {note.payrollDate?moment(note.payrollDate).format('MMM YYYY'):''}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                            {note.noteField && `Field: ${note.noteField} | `}
                            By: {note.noteBy} | Date: {moment(note.noteDate).format('DD/MM/YYYY HH:mm')}
                        </Typography>
                    </div>
                ))}
            </ExpansionPanelDetails>
        </ExpansionPanel>
        </Grid>
    )}

    </Grid>
  

</div>
}

function useForceUpdate() {
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => ++value); // update the state to force render
}

let tempSet = false;
const RunPayroll = props => {
    const id = +props.id;
    const exportExcel = useRef();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const checkpointId = queryParams.get('checkpoint');

    const {payrolls: payrollData, site, employmentType, description, payrollStatus, firstRun, costCenter, region, usedCurrencyRates} = props.runPayroll


    // const [site, setSite] = useState(0);
//console.log(payrollData)
    const dispatch = useDispatch();

    useEffect(() => {
        // console.log(props.runPayroll)
        if (payrollData.length) {
            dispatch({type: 'PAYROLLRUN_SET_FIRST_RUN', payload: false});
        }

        dispatch({type: 'LOAD_COMPANY_SETTINGS'})

        const initializePayroll = async () => {
            if (checkpointId) {
                try {
                    const allCheckpoints = await indexedDBService.getCheckpoints();
                    const checkpoint = allCheckpoints.find(cp => cp.checkpointId === checkpointId);
                    if (checkpoint) {
                        props.loadSavedState(checkpoint);
                        return; // Skip regular loading if checkpoint was loaded
                    }
                } catch (error) {
                    console.error('Failed to load checkpoint:', error);
                }
            }

            // Regular loading logic if no checkpoint or checkpoint loading failed
            else if (!id && payrollData.length === 0) {
                console.log("pd",props.runPayroll.payrollDate)
                dispatch({type: 'LOAD_PAYROLL_EMPLOYEES', payload:{payrollDate:moment(props.runPayroll.payrollDate)}});
            }
           else if (id) {
                setFilter(undefined);
                dispatch({type: 'CLEAR_PAYROLL'})
                dispatch({type: 'LOAD_PAYROLLRUN', payload: {id}})
            }
        };

        initializePayroll();
    }, [checkpointId]); // Add checkpointId to dependencies

    useEffect(() => {
        let filters = []
        if(site) filters.push({field: "siteName", operator: "eq", value: site})
        if(region) filters.push({field: "regionName", operator: "eq", value: region})
        setFilter({filters, logic: "and"})
    }, [site, region])


    const {data: OvertimeTypes} = useQueryWithStore({
        type: 'getList',
        resource: 'overtimeTypes'
    });

    const {data: sites} = useQueryWithStore({
        type: 'getList',
        resource: 'sites',
        payload: {filter: {}, pagination: {}, sort: {}}
    });
const {data: regions} = useQueryWithStore({
    type: 'getList',
    resource: 'regions',
    payload: {filter: {}, pagination: {}, sort: {}}
});

    const {data: costCenters} = useQueryWithStore({
        type: 'getList',
        resource: 'costCenters',
        payload: {filter: {}, pagination: {}, sort: {}}
    });

    const employmentTypes = [
        { id: 'FullTime', name: 'FullTime' },
        { id: 'Contract', name: 'Contract' },
        { id: 'PartTime', name: 'PartTime' },
        { id: 'InternOrFellow', name: 'InternOrFellow' },
        { id: 'Casual', name: 'Casual' },
    ]
    const payrollStates = [
        {id: 'Processing', name: 'Processing'},
        {id: 'Paid', name: 'Paid'},
        {id: 'Held', name: 'Held'},
    ]
    const [editID, setEditID] = useState(null);
    const forceUpdate = useForceUpdate();
    const [sort, setSort] = useState([
        {field: 'fullName', dir: 'asc'}
    ]);


    const [filter, setFilter] = useState(site ? {
        filters: [{field: "siteName", operator: "eq", value: site}],
        logic: "and"
    } : {filters: [], logic: "and"});
    // console.log({site,filter})
    const [additionalFilters, setAdditionalFilters] = useState([])
    const [nameFilter, setNameFilter] = useState(null)
    const [employeeSearch, setEmployeeSearch] = useState("")

    const [periodRange, setPeriodRange] = React.useState({
        start: moment(props.runPayroll.periodStart).toDate(),
        end: moment(props.runPayroll.periodEnd).toDate()
    });
    if (!tempSet && (moment(props.runPayroll.periodStart).format('YYYY-MM-DD') !== moment(periodRange.start).format('YYYY-MM-DD') ||
        moment(props.runPayroll.periodEnd).format('YYYY-MM-DD') !== moment(periodRange.end).format('YYYY-MM-DD')
    )) {
        setPeriodRange({
            start: moment(props.runPayroll.periodStart).toDate(),
            end: moment(props.runPayroll.periodEnd).toDate()
        })
    }
    //const payrollData = [{id:1,name:'x',place:'cast'},{id:2,name:'y',place:'las'},{id:74,name:'z',place:'tas'}]
    const columns = [
        {key: 'name', name: 'name', sortable: true},
        {key: 'place', name: 'Place', sortable: true}
    ];
    const reset = () => {
          props.saveCheckpoint();
        // console.log('reset')
        dispatch({type: 'LOAD_PAYROLL_EMPLOYEES', payload: {refresh: false, payrollDate:props.runPayroll.payrollDate}})
        setFilter(undefined);
    };

    const refresh = () => dispatch({type: 'LOAD_PAYROLL_EMPLOYEES', payload: {refresh: true, payrollDate:props.runPayroll.payrollDate}});

    const refreshSelected = (employeeIds) => {
        dispatch({
            type: 'LOAD_SELECTED_PAYROLL_EMPLOYEES',
            payload: {
                employeeIds,
                refresh: true,
                payrollDate: props.runPayroll.payrollDate
            }
        });
    };

    const exportToExcel = () => {
        exportExcel.current.save();
    }

    const [filteredPayroll, setFilteredPayroll] = useState([])
    const [markAllPublished,setMarkAllPublished] = useState(false)
    const [markAllSent,setMarkAllSent] = useState(false)
    const [markAllPayrollStatus,setMarkAllPayrollStatus] = useState('Processing')
    const [withReviewNotes, setWithReviewNotes] = useState(false);
    const [reviewPopoverAnchor, setReviewPopoverAnchor] = useState(null);

    useEffect(() => {
        let payrolls = payrollData.map((p) => {
            const item = {}
            item.inEdit = p.id === editID
            item.totalDeductionIncludingCash = p.totalDeductionIncludingCash || p.totalDeduction + p.payrollDeductionTotalCash
            if (costCenter && p.costCenterItems && p.costCenterItems.length) {
                const cs = p.costCenterItems.find(c => c.costCenterCode === costCenter)
                if (cs) {
                    item.cash = cs.cash
                    item.costCenterCode = cs.costCenterCode
                    item.totalIncome = cs.totalIncome
                    item.netPay = cs.netPay
                    item.incomeTax = cs.incomeTax
                    item.taxableIncome = cs.taxableIncome
                }
            }
            return {...p, ...item}
        });
        if (withReviewNotes) {
            payrolls = payrolls.filter(p => p.reviewNotes && p.reviewNotes.length > 0);
        }
        setFilteredPayroll(filterBy(orderBy(payrolls, sort), filter))
    }, [payrollData, filter, withReviewNotes, sort])


    const TotalCell = (props) => {
        const sum = filteredPayroll.reduce((acc, current) => acc + current[props.field], 0);
        const count = filteredPayroll.length
        //const max = products.reduce((acc, current) => Math.max(acc, current[props.field]), 0);
        return (
            <td colSpan={props.colSpan} style={{fontSize: 'small'}}>
                {props.type === "count" ? count : (+sum.toFixed(2)).toLocaleString()}
            </td>
        );
    }
    const handlePeriodChange = (ev) => {
        const range = ev.target.value;
        tempSet = true
        setPeriodRange(range)
        if (range && range.start && range.end) {
            props.onPayrollDateChanged({periodStart: range.start, periodEnd: range.end})
            tempSet = false
        }
    }


    // if (props.loading) { return <Loading />; }

    const handleNameFilterChange = (e) => {
        // console.log(e.filter)
        setNameFilter(e.filter)
    }

    const handleFieldChange = (field,val,ids) => {
        dispatch({
            type: 'PAYROLLS_SET_FIELD',
            payload: {field,val,ids}
        })
    }

    const [anchorEl, setAnchorEl] = useState(null);

    // Remove useMemo for checkpoints and use useState + useEffect instead
    const [checkpoints, setCheckpoints] = useState([]);

    useEffect(() => {
        let isMounted = true;
        async function loadCheckpoints() {
            const allCheckpoints = await indexedDBService.getCheckpoints();
            let currentPayrollDate;
            try {
                currentPayrollDate = moment(props.runPayroll.payrollDate);
                if (!currentPayrollDate.isValid()) {
                    currentPayrollDate = moment();
                }
            } catch (e) {
                currentPayrollDate = moment();
            }
            const filtered = allCheckpoints
                .filter(checkpoint => {
                    let cpDate;
                    try {
                        cpDate = moment(checkpoint.payrollDate);
                        if (!cpDate.isValid()) {
                            cpDate = moment();
                        }
                    } catch (e) {
                        cpDate = moment();
                    }
                    return checkpoint.companyId === props.companyId &&
                        cpDate.format('YYYY-MM') === currentPayrollDate.format('YYYY-MM');
                })
                .sort((a, b) => {
                    let aDate = moment(a.savedOn);
                    let bDate = moment(b.savedOn);
                    if (!aDate.isValid()) aDate = moment();
                    if (!bDate.isValid()) bDate = moment();
                    return bDate - aDate;
                });
            if (isMounted) setCheckpoints(filtered);
        }
        loadCheckpoints();
        return () => { isMounted = false; };
    }, [props.companyId, props.runPayroll.payrollDate]);

    const handleSaveState = () => {
        props.saveCheckpoint();
    };

    const handleLoadState = async (checkpointSummary) => {
        try {
            const allCheckpoints = await indexedDBService.getCheckpoints();
            const fullCheckpoint = allCheckpoints.find(cp => cp.checkpointId === checkpointSummary.checkpointId);
            if (fullCheckpoint) {
                // Properly deserialize before loading
                const deserialized = indexedDBService.deserializeCheckpoint(fullCheckpoint);
                props.loadSavedState(deserialized);
            }
        } catch (e) {
            console.error('Failed to load full checkpoint:', e);
        }
        setAnchorEl(null);
    };

    // const handleDeleteCheckpoint = (checkpointId, event) => {
    //     event.stopPropagation();
    //     // Get all checkpoints
    //     const allCheckpoints = JSON.parse(localStorage.getItem('payrollCheckpoints') || '[]');
    //     const updatedAllCheckpoints = allCheckpoints.filter(cp => cp.checkpointId !== checkpointId);
    //     localStorage.setItem('payrollCheckpoints', JSON.stringify(updatedAllCheckpoints));
        
    //     // Update displayed checkpoints (only for current payroll month)
    //     const currentPayrollDate = moment(props.runPayroll.payrollDate);
    //     const relevantCheckpoints = updatedAllCheckpoints.filter(checkpoint => 
    //         moment(checkpoint.payrollDate).format('YYYY-MM') === currentPayrollDate.format('YYYY-MM')
    //     );
    //     dispatch({type: 'UPDATE_PAYROLL_CHECKPOINTS', payload: relevantCheckpoints});
    // };

    const formatDate = (dateString) => {
        return moment(dateString).format('DD/MM/YY h:mm A');
    };

    // useEffect(() => {
    //     async function loadCheckpointsToRedux() {
    //         try {
    //             const allCheckpoints = await indexedDBService.getCheckpoints();
    //             // Only store summary metadata in Redux
    //             const checkpointSummaries = allCheckpoints.map(cp => ({
    //                 checkpointId: cp.checkpointId,
    //                 payrollDate: cp.payrollDate,
    //                 savedBy: cp.savedBy,
    //                 savedOn: cp.savedOn,
    //                 autosaved: cp.autosaved,
    //                 companyId: cp.companyId,
    //                 description: cp.description
    //             }));
    //             dispatch({
    //                 type: 'PAYROLL_CHECKPOINTS_LOADED',
    //                 payload: { checkpoints: checkpointSummaries }
    //             });
    //         } catch (e) {
    //             console.error('Failed to load checkpoints:', e);
    //         }
    //     }
    //     loadCheckpointsToRedux();
    // }, [props.companyId, props.runPayroll.payrollDate]);

    const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
    const openMoreMenu = Boolean(moreMenuAnchorEl);
    const [refreshSelectedOpen, setRefreshSelectedOpen] = useState(false);
    const [bulkDeductionOpen, setBulkDeductionOpen] = useState(false);

    const handleBulkDeduction = (deductions, employeeIds) => {
        dispatch({
            type: 'PAYROLLS_SET_FIELD',
            payload: { field: 'payrollDeductions', val: deductions, ids: employeeIds }
        });
        setBulkDeductionOpen(false);
    };

    return (
        <MultiCurrencyContext.Provider value={props.runPayroll.currencyRate}>
            <div>
                {/*{props.runPayroll.periodStart}*/}
                {/*From {multiDateFun(props.runPayroll.calendar,moment(props.runPayroll.periodStart).toDate(),'MMMM D') } to {multiDateFun(props.runPayroll.calendar,moment(props.runPayroll.periodEnd).toDate(),'MMMM D')}*/}
                <DateRangePicker value={periodRange} format={'MMMM d'} onChange={handlePeriodChange}/>


                {/*<DatePicker*/}
                {/*    label="From"*/}
                {/*    margin="dense"*/}
                {/*    value={props.runPayroll.periodStart} onChange={periodStart=>props.onPayrollDateChanged({periodStart})} />*/}

                {/*<DatePicker*/}
                {/*    label="To"*/}
                {/*    margin="dense"*/}
                {/*    value={props.runPayroll.periodEnd} onChange={periodEnd=>props.onPayrollDateChanged({periodEnd})}  />*/}

                <PayrollExcelExport ref={exportExcel}
                                    data={filteredPayroll.map((item, i) =>
                                        ({...item, sn: i + 1})
                                    )}
                                    fileName={`PayDay ${props.companyName} Run ${moment(props.runPayroll.payrollDate).format('MMMM YYYY')} ${region ? region + ' ' : ''}${site || ''}.xlsx`}/>


                <KGrid style={{maxHeight: '120vh'}} editField="inEdit"
                       resizable
                       detail={ConnectedDetail}
                       expandField="expanded"
                       onExpandChange={props.onExpandChange}
                    //    onItemChange={handleItemChange}
                       data={filteredPayroll}
                       onRowClick={event => setEditID(event.dataItem.id)}
                       sortable
                       filter={nameFilter}
                       sort={sort}
                       onSortChange={(e) => {
                           //  console.log(e.sort)
                           setSort(e.sort)

                       }} onFilterChange={(e) => {
                    // console.log(e)
                    //
                    //     const nameFilters = e.filter.filters.filter(f=>f.field==='fullName')
                    //     const nameFilter = {filters:nameFilters, logic:'or'}
                    //     const otherFilters = filter.filters.filter(f=>f.field)
                    //    const newFilter = {filters:[nameFilter], logic:"and"}
                    //
                    //    console.log({nameFilters,newFilter,otherFilters})

                    setNameFilter(e.filter)


                    const otherFilters = (filter && filter.filters && filter.filters.filter(f => f.field)) || []
                    if (e.filter.filters && e.filter.filters.length)
                        setFilter({filters: [...otherFilters, e.filter], logic: "and"})
                    else setFilter({filters: [...otherFilters], logic: "and"})


                }}
                >
                    <GridToolbar>
                        <div onClick={event => setEditID(null)}>
                            <Grid container>
                                <Grid item md={2} container direction='column'>
                                    <div>
                                    <DropMenuButton
                                      mainButtonProps={{
                                        onClick: refresh,
                                        variant: 'contained',
                                        color: 'primary',
                                        style: { width: '100%' },
                                        startIcon: null,
                                        children: 'ReFresh'
                                      }}
                                      menuItems={[
                                          {
                                              label: 'Refresh Selected',
                                              onClick: () => setRefreshSelectedOpen(true)
                                          }
                                      ]}
                                    />
                                    </div>
                                    
                                    

                                    {props.companyMateId && props.companyMateId !== 'null' && props.companyMateId === 'deweto' &&
                                    <SyncMatesDialog firstRun={firstRun}/>}


                                    <WithConfirm
                                        style={{width:'100%'}}
                                        title="Reset Payroll?"
                                        content={
                                            "This will discard all changes made to the payroll. A checkpoint will be created before resetting in case you need to recover your changes."
                                        }
                                        onConfirm={reset}
                                    >
                                       <KButton
                                        icon="reset"
                                        title="Reset"
                                        className="k-error-colored"
                                      
                                    >
                                        Reset
                                    </KButton>

                                    </WithConfirm>
                                    {props.isEdit&&
                                    <ExpansionPanel>
                                    <ExpansionPanelSummary>
                                        <Typography>Mark All</Typography>
                                    </ExpansionPanelSummary>
                                    <Grid container>

                                        <Grid item>
                                        <FormControlLabel
                                            control={<Checkbox checked={markAllSent} onChange={e => {
                                                setMarkAllSent(e.target.checked)
                                                return handleFieldChange('emailSent', e.target.checked, filteredPayroll.map(p=>p.employeeId))
                                            }
                                            }  />}

                                            label="Mark all as Sent"
                                        />
                                        <FormControlLabel
                                            control={<Checkbox checked={markAllPublished} onChange={e => {
                                                setMarkAllPublished(e.target.checked)
                                                    return handleFieldChange('publishId', e.target.checked ? -1 : 0, filteredPayroll.map(p=>p.employeeId))
                                            }} />}
                                            label="Mark all as Published"
                                        />
                                        </Grid>
                                        <Grid item>
                              
                                         <RadioGroup
                                            row
                                            value={markAllPayrollStatus}
                                            onChange={e => {
                                                setMarkAllPayrollStatus(e.target.value)
                                                return handleFieldChange('status', e.target.value, filteredPayroll.map(p=>p.employeeId))
                                            }}
                                         >
                                            <FormControlLabel value="Paid" control={<Radio />} label="Paid" />
                                            <FormControlLabel value="Held" control={<Radio />} label="Held" />
                                            <FormControlLabel value="Processing" control={<Radio />} label="Processing" />
                                            </RadioGroup>
                                            </Grid>
                                    </Grid>
                                    </ExpansionPanel>
                                    }

                                    <Button
                                        startIcon={<SaveIcon />}
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSaveState}
                                        style={{ marginTop: 8 }}
                                    >
                                        Save Checkpoint
                                    </Button>
                                    
                                    <Button
                                        startIcon={<RestoreIcon />}
                                        variant="contained"
                                        color="secondary" 
                                        onClick={(e) => setAnchorEl(e.currentTarget)}
                                        style={{ marginTop: 8 }}
                                        disabled={checkpoints.length === 0}
                                    >
                                        Load Checkpoint
                                    </Button>
                                    <FormControl margin='dense' style={{width: '100%'}}>
                                        <TextField
                                            label="Search Employee"
                                            value={employeeSearch}
                                            onChange={e => {
                                                const val = e.target.value;
                                                setEmployeeSearch(val);
                                                const f = filter && filter.filters ? filter.filters.filter(fl => fl.field !== "fullName") : [];
                                                if (val) {
                                                    f.push({field: "fullName", operator: "contains", value: val});
                                                }
                                                setFilter({filters: f, logic: "and"});
                                            }}
                                            InputProps={{
                                                endAdornment: employeeSearch ? (
                                                    <InputAdornment position="end">
                                                        <IconButton size="small" onClick={() => {
                                                            setEmployeeSearch("");
                                                            const f = filter && filter.filters ? filter.filters.filter(fl => fl.field !== "fullName") : [];
                                                            setFilter({filters: f, logic: "and"});
                                                        }}>
                                                            <CancelIcon fontSize="small" />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ) : (
                                                    <InputAdornment position="end">
                                                        <SearchIcon fontSize="small" />
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </FormControl>

                                </Grid>

                                {/*<KButton icon="folder" className="k-info-colored" >Browse</KButton>*/}
                                <Grid item md={1}>
                                    <KButton
                                        icon="excel"
                                        title="Export to Excel"
                                        className="k-success-colored"
                                        onClick={exportToExcel}
                                    >
                                        Export to Excel
                                    </KButton>
                                    <MergePayrollDialog payrollRun={props.runPayroll} id={id}/>
                                   

                                </Grid>

                                <Grid item md={3} container direction='column'>
                                    <SetTimeSheetDialog site={site} unProccesedTimeSheet={props.runPayroll.unProccesedTimeSheet} payrolls={props.runPayroll.payrolls}
                                                        payrollDate={props.runPayroll.payrollDate}
                                                        periodStart={props.runPayroll.periodStart}
                                                        periodEnd={props.runPayroll.periodEnd} payrollData={payrollData}
                                                        OvertimeTypes={OvertimeTypes} refreshPayrollData={refresh}/>
                                    <DistEarnings groups={sites} payrollRun={props.runPayroll}
                                                  distEarnings={props.runPayroll.distEarnings}/>
                                    <GroupBonus/>
                                    <ImportEarningsDeductionsFromFile key={"importDeductions"} />
                                    <ImportPayrollUpdates key={"importUpdates"} payrolls={props.runPayroll.payrolls} payrollRun={props.runPayroll} currentUser={props.currentUser}/>
                                    {filteredPayroll.length > 0 && (
                                        <div style={{ marginTop: 8 }}>
                                            <Button
                                               
                                                color="primary"
                                                onClick={() => setBulkDeductionOpen(true)}
                                            >
                                                Bulk Deduction for {filteredPayroll.length} Employee{filteredPayroll.length !== 1 ? 's' : ''}
                                            </Button>
                                        </div>
                                    )}
                                </Grid>


                                <Grid item md={1}>
                                    <div style={{marginLeft:-10}}>
                                        <FormControlLabel
                                            labelPlacement='bottom'
                                            control={<Switch
                                                checked={props.dockVisible}
                                                onChange={props.toggleDockVisible}
                                                value="Summery"
                                                color="primary"
                                                inputProps={{'aria-label': 'secondary checkbox'}}
                                            />
                                            }
                                            label="Summery"
                                        />
                                    </div>
                               {props.runPayroll.remarks && props.runPayroll.remarks.length>0 &&     <div>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={withReviewNotes}
                                                    onChange={e => setWithReviewNotes(e.target.checked)}
                                                    color="primary"
                                                />
                                            }
                                  
                                            style={{ marginLeft: 0, marginTop: 8 }}
                                        />
                                            <span
                                                    style={{ cursor: 'pointer', textDecoration: 'underline', color: '#1976d2', marginLeft: -20 }}
                                                    onClick={e => setReviewPopoverAnchor(e.currentTarget)}
                                                >
                                                   With Review Notes
                                                </span>
                                        <Popover
                                            open={Boolean(reviewPopoverAnchor)}
                                            anchorEl={reviewPopoverAnchor}
                                            onClose={() => setReviewPopoverAnchor(null)}
                                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                        >
                                            <div style={{ padding: 16, maxWidth: 350, maxHeight: 400, overflowY: 'auto' }}>
                                                <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: 8 }}>Payrolls with Review Notes</Typography>
                                                {payrollData.filter(p => p.reviewNotes && p.reviewNotes.length > 0).length === 0 && (
                                                    <Typography variant="body2">No payrolls with review notes.</Typography>
                                                )}
                                                {payrollData.filter(p => p.reviewNotes && p.reviewNotes.length > 0).map((p, idx) => (
                                                    <div key={p.id || idx} style={{ marginBottom: 12 }}>
                                                        <Typography variant="body2" style={{ fontWeight: 'bold' }}>{p.fullName}</Typography>
                                                        {p.reviewNotes.map((n, i) => (
                                                            <div key={i} style={{ marginLeft: 8, marginBottom: 4, padding: 6, border: '1px solid #eee', borderRadius: 4 }}>
                                                                <Typography variant="body2" style={{ marginBottom: 2 }}><strong>Note:</strong> {n.note}</Typography>
                                                                <Typography variant="caption" color="textSecondary">
                                                                    By {n.remarkUser} on {moment(n.remarkDate).format('YYYY-MM-DD HH:mm')}
                                                                </Typography>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ))}
                                            </div>
                                        </Popover>
                                    </div>}
                                </Grid>
                                <Grid item md={2} container direction="column">


                                    <DatePicker
                                        views={["year", "month"]}
                                        label="Payroll Month"
                                        margin="dense"
                                        // minDate={new Date("2018-03-01")}
                                        // maxDate={new Date("2018-06-01")}

                                        value={props.runPayroll.payrollDate}
                                        onChange={payrollDate => props.onPayrollDateChanged({payrollDate})}/>
                                    <TextField margin='dense' multiline label="Description" value={description}
                                               onChange={ev => {
                                                   dispatch({
                                                       type: 'PAYROLL_DESCRIPTION_CHANGED',
                                                       payload: {description: ev.target.value}
                                                   })
                                               }}/>
                                </Grid>

                                <Grid item md={2} container direction="column">
<FormControl margin='dense'>
    <InputLabel shrink id="region-select-label">
        Region
    </InputLabel>
    <Select
        value={region}
        onChange={ev => {
            dispatch({
                type: 'PAYROLL_REGION_CHANGED',
                payload: {region: ev.target.value}
            })
            const filters = filter && filter.filters ? filter.filters.filter(f => f.field !== "regionName") : []
            if (ev.target.value) {
                filters.push({
                    field: "regionName",
                    operator: "eq",
                    value: ev.target.value
                })
            }
            setFilter({filters, logic: "and"});
        }}
    >
        <MenuItem key={0} value={null}>All Regions</MenuItem>
        {regions && regions.map(r => <MenuItem key={r.id} value={r.name}>{r.name}</MenuItem>)}
    </Select>
</FormControl>
                                    <FormControl margin='dense'>
                                        <InputLabel shrink id="demo-simple-select-placeholder-label-label">
                                            Current Site
                                        </InputLabel>

                                        <Select
                                            value={site}
                                            onChange={ev => {
                                                // setSite(ev.target.value)
                                                dispatch({
                                                    type: 'PAYROLL_SITE_CHANGED',
                                                    payload: {site: ev.target.value}
                                                })

                                                const filters = filter && filter.filters ? filter.filters.filter(f => f.field !== "siteName") : []

                                                if (ev.target.value) {
                                                    filters.push({
                                                        field: "siteName",
                                                        operator: "eq",
                                                        value: ev.target.value
                                                    })
                                                    // const filters = [{field: "siteName", operator: "eq", value: ev.target.value}]
                                                    // employmentType&&filters.push({field: "employmentType", operator: "eq", value: employmentType})
                                                    // setFilter({filters,logic:"and"});

                                                }
                                                // else {
                                                //     const filters = filter.filters.filter(f=>f.field!=="siteName")
                                                //     setFilter({filters,logic:"and"});
                                                //   //  setFilter(employmentType?{filters:[{field: "employmentType", operator: "eq", value: employmentType}],logic:"and"}:undefined);
                                                // }


                                                setFilter({filters, logic: "and"});
                                                // setSite(ev.target.value)
                                                // handelSort(sort.field,payrollRun.payrolls.filter(p=>ev.target.value===0||p.siteName===ev.target.value))
                                                // // payrollRun.filteredPayrolls=filteredPayrolls
                                                //   props.onChange({type:ev.target.value,hrs})
                                            }}
                                        >
                                            <MenuItem key={0} value={null}>All Sites</MenuItem>
                                            {sites && sites.map(ot => <MenuItem key={ot.id}
                                                                                value={ot.name}>{ot.name}</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                    <FormControl margin='dense'>
                                        <InputLabel shrink id="demo-simple-select-placeholder-label-label">
                                            Employment Type
                                        </InputLabel>

                                        <Select
                                            value={employmentType}
                                            onChange={ev => {
                                                // setSite(ev.target.value)
                                                dispatch({
                                                    type: 'PAYROLL_EMPLOYMENT_TYPE_CHANGED',
                                                    payload: {employmentType: ev.target.value}
                                                })
                                                const filters = filter && filter.filters ? filter.filters.filter(f => f.field !== "employmentType") : []

                                                if (ev.target.value) {

                                                    filters.push({
                                                        field: "employmentType",
                                                        operator: "eq",
                                                        value: ev.target.value
                                                    })
                                                    // const filters = [{field: "employmentType", operator: "eq", value: ev.target.value}]
                                                    // site&&filters.push({field: "siteName", operator: "eq", value: site})
                                                    //  setFilter({filters,logic:"and"});

                                                }
                                                setFilter({filters, logic: "and"});
                                                // else {
                                                //
                                                //    // setFilter(site?{filters:[{field: "siteName", operator: "eq", value: site}],logic:"and"}:undefined);
                                                // }


                                                // setSite(ev.target.value)
                                                // handelSort(sort.field,payrollRun.payrolls.filter(p=>ev.target.value===0||p.siteName===ev.target.value))
                                                // // payrollRun.filteredPayrolls=filteredPayrolls
                                                //   props.onChange({type:ev.target.value,hrs})
                                            }}
                                        >
                                            <MenuItem key={0} value={null}>All Employees</MenuItem>
                                            {employmentTypes.map(ot => <MenuItem key={ot.id}
                                                                                 value={ot.name}>{ot.name}</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item md={1} container direction="column">
                                    <FormControl margin='dense'>
                                        <InputLabel shrink id="demo-simple-select-placeholder-label-label">
                                            Status
                                        </InputLabel>

                                        <Select
                                            value={payrollStatus}
                                            onChange={ev => {
                                                // setSite(ev.target.value)
                                                dispatch({
                                                    type: 'PAYROLL_STATUS_CHANGED',
                                                    payload: {status: ev.target.value}
                                                })

                                                const filters = filter.filters ? filter.filters.filter(f => f.field !== "status") : []

                                                if (ev.target.value) {

                                                    filters.push({
                                                        field: "status",
                                                        operator: "eq",
                                                        value: ev.target.value
                                                    })
                                                    // employmentType&&filters.push({field: "employmentType", operator: "eq", value: employmentType})
                                                    // site&&filters.push({field: "siteName", operator: "eq", value: site})
                                                    // setFilter({filters,logic:"and"});

                                                }
                                                // else {
                                                //     const filters = filter.filters.filter(f=>f.field!=="status")
                                                //     // employmentType&&filters.push({field: "employmentType", operator: "eq", value: employmentType})
                                                //     // site&&filters.push({field: "siteName", operator: "eq", value: site})
                                                //   //  setFilter({filters,logic:"and"});
                                                // }
                                                setFilter({filters, logic: "and"});

                                                // setSite(ev.target.value)
                                                // handelSort(sort.field,payrollRun.payrolls.filter(p=>ev.target.value===0||p.siteName===ev.target.value))
                                                // // payrollRun.filteredPayrolls=filteredPayrolls
                                                //   props.onChange({type:ev.target.value,hrs})
                                            }}
                                        >
                                            <MenuItem key={0} value={null}>All Status</MenuItem>
                                            {payrollStates.map(ot => <MenuItem key={ot.id}
                                                                               value={ot.name}>{ot.name}</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                    <FormControl margin='dense'>
                                        <InputLabel shrink id="demo-simple-select-placeholder-label-label">
                                            Cost Center
                                        </InputLabel>

                                        <Select
                                            value={costCenter}
                                            onChange={ev => {
                                                // setSite(ev.target.value)
                                                dispatch({
                                                    type: 'PAYROLL_COST_CENTER_CHANGED',
                                                    payload: {costCenter: ev.target.value}
                                                })


                                                const filters = filter && filter.filters ? filter.filters.filter(f => f.field !== "costCenterCode") : []

                                                if (ev.target.value) {

                                                    filters.push({
                                                        field: "costCenterCode",
                                                        operator: "eq",
                                                        value: ev.target.value
                                                    })
                                                    // const filters = [{field: "employmentType", operator: "eq", value: ev.target.value}]
                                                    // site&&filters.push({field: "siteName", operator: "eq", value: site})
                                                    //  setFilter({filters,logic:"and"});

                                                }
                                                setFilter({filters, logic: "and"});
                                                // else {
                                                //
                                                //    // setFilter(site?{filters:[{field: "siteName", operator: "eq", value: site}],logic:"and"}:undefined);
                                                // }


                                                // setSite(ev.target.value)
                                                // handelSort(sort.field,payrollRun.payrolls.filter(p=>ev.target.value===0||p.siteName===ev.target.value))
                                                // // payrollRun.filteredPayrolls=filteredPayrolls
                                                //   props.onChange({type:ev.target.value,hrs})
                                            }}
                                        >
                                            <MenuItem key={0} value={null}>All Cost Centers</MenuItem>
                                            {costCenters && costCenters.map(ot => <MenuItem key={ot.id}
                                                                                            value={ot.code || ot.name}>{ot.name}</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                    <div>
                                       
                                        <CurrencyRatesPopover 
                                            usedCurrencyRates={props.runPayroll.usedCurrencyRates}
                                            onCurrencyChanged={props.onCurrencyChanged}
                                        />
                                    </div>
                                </Grid>
                              

                            </Grid>

                        </div>
                    </GridToolbar>
                    <Column field="orgID" width={80} title="Work ID" editable={false}    columnMenu={props => <GridColumnMenuCheckboxFilter
                            data={payrollData.filter(p => !site || p.siteName === site)}
                            searchBoxFilterOperator="contains"
                                expanded={true} {...props}/>}/>
                    <Column field="fullName" className="fullName" width={200} title="Name" editable={false}
                        footerCell={props => <TotalCell {...props} type="count" />}
                        cell={NameCell}
                        columnMenu={props => <GridColumnMenuCheckboxFilter
                            data={payrollData.filter(p => !site || p.siteName === site)}
                             searchBoxFilterOperator="contains"
                                expanded={true} {...props}/>}/>
                    <Column field="siteName" title="Current Site" editable={false}/>
                    <Column field="basicSalary" format="{0:n2}" title="Basic Salary" footerCell={TotalCell}
                            cell={MultiCurrencyCell} editable={false}/>

                    <Column field="additionalEarningsTotal" format="{0:n2}" title="Additional Earnings"
                            footerCell={TotalCell} cell={MultiCurrencyCell} editable={false}/>
                    <Column field="totalDeductionIncludingCash" title="Deductions with Settlements" format="{0:n2}"
                            editable={false} footerCell={TotalCell} cell={MultiCurrencyCell}/>
                    <Column field="cash" title="NetPay" format="{0:n2}" editable={false} footerCell={TotalCell}
                            cell={MultiCurrencyCell}/>
                    <Column field="remarks" title="Remarks" editable={false} width={200} cell={RemarksCell}/>
                    {/*<Column field="daysWorked" title="Days Worked" editor="numeric"  />*/}
                    {/*<Column field="place" title="Place" editor="text"   />*/}
                </KGrid>

                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => setAnchorEl(null)}
                >
                    {checkpoints.length === 0 ? (
                        <MenuItem disabled>
                            <ListItemText 
                                primary="No checkpoints available"
                                secondary={`for ${moment(props.runPayroll.payrollDate).format('MMMM YYYY')}`}
                            />
                        </MenuItem>
                    ) : (
                        checkpoints.map((checkpoint) => (
                            <MenuItem 
                                key={checkpoint.checkpointId}
                                onClick={() => handleLoadState(checkpoint)}
                            >
                                <ListItemText
                                    primary={
                                        <Typography variant="subtitle2" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            color: checkpoint.autosaved ? '#666' : 'inherit'
                                        }}>
                                            {checkpoint.autosaved ? (
                                                <AutorenewIcon style={{ marginRight: 8, fontSize: 20 }} />
                                            ) : (
                                                <SaveIcon style={{ marginRight: 8, fontSize: 20 }} />
                                            )}
                                            {/* Show default label and append description if available */}
                                            {(() => {
                                                const defaultLabel = (checkpoint.autosaved ? 'Autosaved' : moment(checkpoint.payrollDate).format('MMM YYYY') + ' Payroll');
                                                return checkpoint.description ? `${defaultLabel} - ${checkpoint.description}` : defaultLabel;
                                            })()}
                                        </Typography>
                                    }
                                    secondary={
                                        <>
                                            {checkpoint.autosaved ? 'Last autosaved' : 'Saved by'} {checkpoint.savedBy} on {formatDate(checkpoint.savedOn)}
                                        </>
                                    }
                                />
                                {/* <ListItemSecondaryAction>
                                    <IconButton 
                                        edge="end" 
                                        aria-label="delete"
                                        onClick={(e) => handleDeleteCheckpoint(checkpoint.checkpointId, e)}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </ListItemSecondaryAction> */}
                            </MenuItem>
                        ))
                    )}
                </Menu>

                <RefreshSelectedDialog
                    open={refreshSelectedOpen}
                    onClose={() => setRefreshSelectedOpen(false)}
                    onRefreshSelected={refreshSelected}
                    payrollData={payrollData}
                />

                <BulkDeductionDialog
                    open={bulkDeductionOpen}
                    onClose={() => setBulkDeductionOpen(false)}
                    onSubmit={(deductions, employeeIds) => handleBulkDeduction(deductions, employeeIds)}
                    filteredPayroll={filteredPayroll}
                />

            </div>
        </MultiCurrencyContext.Provider>
    );
};
const mapStateToProps = function (state) {
    return {
        runPayroll: state.runPayroll,
        loading: state.admin.loading,
        dockVisible: state.ui.payrollDockVisible,
        companyName: state.user.currentCompany.name,
        companyMateId: state.user.currentCompany.mateId,
        companyId: state.user.currentCompany.id,
        templateEarnings: state.payrollStatus.templateEarnings,
        isEdit: !!state.runPayroll.createdBy,
        currentUser: state.user.currentUser

    }
}

const mapDispatchToProps = function (dispatch) {
    return {
        onItemChange: (event) => {
            // console.log(event)
            dispatch({type: 'PAYROLL_ITEM_CHANGED', payload: {event}});
        },
        onExpandChange: (event) => {
            dispatch({type: 'PAYROLL_EXPAND_CHANGED', payload: {event}})
        },
        toggleDockVisible: (event) => {
            dispatch({type: 'SET_PAYROLL_DOCK_VISIBLE', payload: event.target.checked})
        },
        onPayrollDateChanged: (dates) => {
            // console.log(date)
            dispatch({type: 'CHANGE_PAYROLL_DATE', payload: dates})
        },

        onCurrencyChanged: (usedCurrencyRates) => {
            console.log(usedCurrencyRates)
            dispatch({ type: 'PAYROLL_CURRENCY_CHANGED', payload: { usedCurrencyRates } })
            dispatch({type: 'LOAD_PAYROLL_EMPLOYEES', payload: {refresh: true}});
        },
        loadSavedState: (checkpoint) => {
            dispatch({ type: 'LOAD_SAVED_PAYROLL_STATE', payload: checkpoint });
        },
        saveCheckpoint: () => {
            dispatch({type: 'SAVE_PAYROLL_CHECKPOINT'});
        }
    }
}

const ConnectedDetail = connect(state => ({
    overtimeTypes: state.admin.customQueries['{"type":"GET_LIST","resource":"overtimeTypes"}']?state.admin.customQueries['{"type":"GET_LIST","resource":"overtimeTypes"}'].data:[],
    isApproved: !!state.runPayroll.approvedBy,
    usedCurrencyRates: state.runPayroll.usedCurrencyRates,
    isEdit: !!state.runPayroll.createdBy,
    currentUser: state.user.currentUser,
    runPayroll: state.runPayroll,
    companySettings: state.setting.companySettings
}), mapDispatchToProps)(DetailPayroll)

export default connect(mapStateToProps, mapDispatchToProps)(RunPayroll);
